<div class="container-premium" *ngIf="carInformacionInicial">
  <div class="grid">
    <div class="col-12 text-center">
      <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
      <span>{{ 'LBL_CONSULTANDO' | translate }}</span>
    </div>
  </div>
</div>

<div class="container-premium" *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'PRODUCTOSTRONCAL.LBL_TITULO' | translate }}">
        <div class="grid form-group align-items-start">
          <div class="col-12 md:col-6 lg:col-3">
            <label class="control-label mr-1">{{ 'PRODUCTOSTRONCAL.LBL_CODIGO' | translate }}:</label>
            <label><strong>{{ productoTroncal.codigo }}</strong></label>
          </div>
          <div class="col-12 md:col-6 lg:col-3">
            <label class="control-label mr-1">{{ 'PRODUCTOSTRONCAL.LBL_NOMBRE' | translate }}:</label>
            <label><strong>{{ productoTroncal.nombre }}</strong></label>
          </div>
          <div class="col-12 md:col-6 lg:col-3">
            <label class="control-label mr-1">{{ 'LBL_TIPO' | translate }}:</label>
            <label>
              <strong>{{ ( productoTroncal.indicadorProducto ? 'PRODUCTOSTRONCAL.LBL_PRODUCTO' : 'PRODUCTOSTRONCAL.LBL_TIPO' ) | translate }}</strong>
            </label>
          </div>
          <div class="col-12 md:col-6 lg:col-3" *ngIf="!productoTroncal.indicadorProducto">
            <label class="control-label mr-1">{{ 'PRODUCTOSTRONCAL.LBL_TIPO' | translate }}:</label>
            <label><strong>{{ productoTroncal.tipoProducto }}</strong></label>
          </div>
        </div>

        <div class="grid form-group align-items-start">
          <div class="col-12 md:col-6 lg:col-3">
            <label class="control-label mr-1">{{ 'PRODUCTOSTRONCAL.LBL_ICONO' | translate }}:</label>
            <div class="flex align-items-center gap-2 mt-2">
              <img *ngIf="imagen" [src]="imagen" alt="icono" style="width: 48px; height: 48px; object-fit: contain;">
              <i *ngIf="!imagen" class="fa fa-image" style="color: #cbd5e1; font-size: 48px;"></i>
              <small>{{ productoTroncal.nombreAdjuntoIcono }}</small>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-3">
            <label class="control-label mr-1">{{ 'LBL_HABILITADO' | translate }}:</label>
            <label>
              <strong>{{ ( productoTroncal.indicadorHabilitado ? 'LBL_SI' : 'LBL_NO' ) | translate }}</strong>
            </label>
          </div>
          <div class="col-12 md:col-6 lg:col-3">
            <label class="control-label mr-1">{{ 'LBL_ORDEN' | translate }}:</label>
            <label><strong>{{ productoTroncal.orden }}</strong></label>
          </div>
        </div>

        <div class="grid" *ngIf="productoTroncal.indicadorProducto">
          <div class="col-12">
            <app-productos-troncal-productos [productos]="productosAgrupados" [verDetalle]="true"></app-productos-troncal-productos>
          </div>
        </div>
      </p-panel>
    </div>
  </div>

  <div class="grid form-footer-buttons mt-4">
    <div class="col-12 flex gap-2">
      <button type="button" pButton class="btn-primary-outline"
              label="{{ 'BTN_REGRESAR' | translate }}"
              (click)="regresar()"></button>
    </div>
  </div>
</div>
